import { useNotes } from '../../api/use-notes'
import { NoteListItem } from '../note-list-item'

interface NoteListProps {
  referralShareId?: number
  leadInquiryId?: number
}

export const NoteList = ({ referralShareId, leadInquiryId }: NoteListProps) => {
  const { data: notes, isLoading, isError } = useNotes(referralShareId, leadInquiryId)

  if (isLoading) {
    return <p className="text-muted">Loading notes...</p>
  }

  if (isError) {
    return <p className="text-destructive">Error loading notes</p>
  }

  return (
    <div>
      {notes?.length === 0 ? (
        <p>No notes yet</p>
      ) : (
        <div className="flex flex-col divide-y-2">
          {notes?.map((note) => (
            <NoteListItem key={note.id} note={note} />
          ))}
        </div>
      )}
    </div>
  )
}
